var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "시설 및 참여",
      "tabActive": "코칭스탭",
      "bg": "/images/sub/visual/sv2.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('dept3-tab', {
    attrs: {
      "page": "코칭스탭",
      "tabActive": "2"
    }
  }), _c('sub-staff-tab'), _c('staff-profile-layout', _vm._b({}, 'staff-profile-layout', _vm.profile, false))], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }